import React, { forwardRef, useState } from 'react';
import { observer } from 'mobx-react-lite';
import { IPushNotification, getAvatarSrc, setClass } from '../../utils';
import { MonthCalendarIcon } from '../svgs';
import { getTimestamp } from '../../utils/helpers/getTimeStamp';
import { PushButtons } from './PushButtons';
import '../../styles/components/pushNotification.scss';

interface PushNotificationProps {
  notification: IPushNotification;
  answerMeeting: (meetingId: string, consumerId: string, confirm: boolean, pushId: number) => void;
  offerTime: (pushId: number, meetingId: string, userId: string, offeredTime: Date) => Promise<void>;
  openMeeting: (id: number, isEditable: boolean) => void;
  isPushInactive: (push: IPushNotification) => boolean;
}

export const PushNotification = observer(forwardRef<HTMLDivElement, PushNotificationProps>(({
  notification: n, openMeeting, answerMeeting, offerTime, isPushInactive,
}, ref) => {
  const [changeListOpen, setChangeListOpen] = useState(false);
  const onChangeListOpen = (e: React.MouseEvent<HTMLElement, MouseEvent>) => {
    e.stopPropagation();
    setChangeListOpen(prev => !prev);
  }
  const now = new Date();
  const timeString = getTimestamp(n.creatingDate, now);
  const onOpen = () => openMeeting(n.meetingId, n.notificationEventType === 'COUNTER_OFFER');
  const onConfirm = () => answerMeeting(n.hashMeetingId, n.hashConsumerId, true, n.id);
  const onCancel = () => answerMeeting(n.hashMeetingId, n.hashConsumerId, false, n.id);
  const onOfferTime = (offeredTime: Date) => offerTime(n.id, n.hashMeetingId, n.hashConsumerId, offeredTime);
  const readClass = isPushInactive(n) && 'read';

  return (
    <div
      className="push-notification"
      onClick={onOpen}
    >
      <div className="push-image">
        {n.pushType === 'PERSON'
          ? (
            <img
              className="avatar"
              src={getAvatarSrc(n.producerId)}
            />
          )
          : (
            <MonthCalendarIcon
              width={16}
              height={18}
              color={n.isViewed ? '#70757A' : null}
            />
          )}
      </div>
      <div>
        <div className="push-text">
          <p className={setClass('push-message', readClass)}>{n.text}</p>
          {n.notificationEventType === 'UPDATE_MEETING' && n.additionalText && (
            <p
              onClick={onChangeListOpen}
              className="push-more-information-button"
            >
              {changeListOpen ? 'Скрыть изменения...' : 'Показать изменения...'}
            </p>
          )}
          {changeListOpen && n.additionalText && (
            n.additionalText.map((change) => (
              <p className={setClass('push-message', readClass)}>{change}</p>
            ))
          )}
          <p className={setClass('push-time', readClass)}>{timeString}</p>
        </div>
        {n.notificationEventType === 'CREATE_MEETING' && !n.isAnswered && (
          <PushButtons
            onCancel={onCancel}
            onConfirm={onConfirm}
            offerTime={onOfferTime}
            ref={ref}
          />
        ) }
      </div>
    </div>
  );
}));
